export default __webpack_public_path__ + "static/media/codingn.92e48348.jpg";